import React, { useMemo } from 'react';
import useBasket from '../../../hooks/basket/useBasket';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import { BasketLineItemModifier } from '../../../store/types';

type NestedModifierProps = {
  data: BasketLineItemModifier;
};

const NestedModifierGroupItem = (props: NestedModifierProps) => {
  const { data } = props;
  const { formatCurrency } = useAppMethods();
  const { compileModifier } = useBasket();
  const entry = useMemo(() => compileModifier(data), [data, compileModifier]);

  return (
    <div className="w-full flex justify-between text-muted-foreground">
      <p>{entry.entry.name}</p>
      {!!entry.actual_price && <p>+ {formatCurrency(entry.actual_price * data.quantity)}</p>}
    </div>
  );
};

export default NestedModifierGroupItem;
